export default "__VITE_ASSET__C4mKsIZ2__"